import { graphql, navigate, useStaticQuery } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useEffect, useState } from 'react';
import Modal from 'src/components/Steps/Modal';
import { SvgImage } from 'src/helpers';
import { InfoVideoButton } from 'src/styles/infoPages';
import { HomePageModalContainer, HomePageModalImageContainer, HomePageModalTitle } from 'src/styles/landingPages';

const modalStyles: React.CSSProperties = { textAlign: 'center' };

const HomePageModal = () => {
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query HomePageModalQuery {
      allContentfulFeatures {
        edges {
          node {
            infoVideoOne {
              svg {
                content: originalContent
              }
              file {
                contentType
              }
            }
            infoVideoTwo {
              svg {
                content: originalContent
              }
              file {
                contentType
              }
            }
          }
        }
      }
    }
  `);

  const { infoVideoOne, infoVideoTwo } = data?.allContentfulFeatures?.edges[0]?.node;

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpenModal(true);
    }, 15000);

    return () => clearTimeout(timer);
  }, []);

  return (
    openModal && (
      <Modal maxWidth="xl" open={openModal} setIsOpen={setOpenModal} messageTitle={''}>
        <div style={modalStyles}>
          <HomePageModalTitle>{t('homePageModal.title')}</HomePageModalTitle>
          <br />
          {t('homePageModal.description')}
          <HomePageModalContainer>
            <InfoVideoButton
              style={{ display: 'inline' }}
              onClick={() => {
                navigate('/features');
              }}
              selected>
              <HomePageModalImageContainer>
                <SvgImage {...infoVideoOne} />
              </HomePageModalImageContainer>
            </InfoVideoButton>
            <InfoVideoButton
              style={{ display: 'inline' }}
              onClick={() => {
                navigate('/features');
              }}
              selected>
              <HomePageModalImageContainer>
                <SvgImage {...infoVideoTwo} />
              </HomePageModalImageContainer>
            </InfoVideoButton>
          </HomePageModalContainer>
        </div>
      </Modal>
    )
  );
};

export default HomePageModal;
